// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgAvatarSilhouette = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={136}
    height={136}
    viewBox="0 0 136 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_1008_6546)">
      <path fill="#181C20" d="M0 0h136v136H0z" />
      <path
        d="M96.333 51c0 15.648-12.685 28.333-28.333 28.333-15.648 0-28.333-12.685-28.333-28.333 0-15.648 12.685-28.333 28.333-28.333 15.648 0 28.333 12.685 28.333 28.333ZM22.667 136c0-25.037 20.296-45.333 45.333-45.333s45.333 20.296 45.333 45.333H22.667Z"
        fill="#343D44"
      />
    </g>
    <defs>
      <clipPath id="clip0_1008_6546">
        <rect width={136} height={136} rx={68} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
))
SvgAvatarSilhouette.displayName = 'SvgAvatarSilhouette'
const Memo = memo(SvgAvatarSilhouette)
export { Memo as SvgAvatarSilhouette }
